import type {ReactNode} from 'react';

import {createView, view} from '@sail/ui';

type Props = {
  header?: ReactNode;
  content?: ReactNode;
  footer?: ReactNode;
};

export const ThreadsScreen = createView(
  ({header, content, footer, ...props}: Props) => {
    return (
      <view.div
        data-testid="threads-screen"
        css={{
          height: 'fill',
          stack: 'y',
          overflow: 'hidden',
        }}
        {...props}
      >
        {header ? (
          <view.div data-testid="threads-screen-header">{header}</view.div>
        ) : null}
        <view.div
          data-testid="threads-screen-content"
          css={{stack: 'y', height: 'fill'}}
        >
          {content}
        </view.div>
        {footer ? (
          <view.div data-testid="threads-screen-footer">{footer}</view.div>
        ) : null}
      </view.div>
    );
  },
);
